module.exports = __webpack_public_path__ + "static/media/parfaite150.06bef511.jpg";